import { Component } from 'react';
import { Navigate } from 'react-router-dom';

import { 
  ThemeProvider, 
  createTheme, 
} from '@mui/material/styles';
import {
  Box,
  Typography,
  FormControl,
  TextField,
  Button,
  Alert,
} from '@mui/material';

import { HttpStatusCode } from 'axios';

import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

import { withTranslation } from 'react-i18next';
// import i18n from '../assets/locales';

import Layout from '../layouts/layout.component';
import UserService from '../services/user.service';

type Props = {};

type State = {
  redirect: string | null,
  email: string,
  loading: boolean,
  success: boolean,
  message: string
};

const theme = createTheme({
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontSize: 13,
          fontWeight: 'bold',
          color: 'rgba(224, 224, 224, 0.98)' ,
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          // Standard
          '& .MuiInput-root': {
            color: 'rgba(255, 255, 255, 0.8)',
            // fontFamily: 'Arial',
            fontWeight: 'bold',
            '&:before': {
              borderColor: 'rgba(128, 128, 128, 0.8)',
              borderWidth: '1px',
            },
            '&:after': {
              borderColor: 'rgba(0, 98, 65, 0.8)',
              borderWidth: '2px',
            },
            ':hover:not(.Mui-focused)': {
              '&:before': {
                borderColor: 'rgba(231, 231, 231, 0.8)',
                borderWidth: '1px',
              },
            },
          },
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          '& .MuiAlert-message': {
            color: 'rgba(0, 0, 0, 1)'
          }
        }
      }
    }
  },
});


class ForgotUsername extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.routeToSignin = this.routeToSignin.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      redirect: null,
      email: '',
      loading: false,
      success: false,
      message: ''
    };
  }

  componentDidMount() {
    // const currentUser = AuthService.getCurrentUser();

    // if (currentUser) {
    //   this.setState({ redirect: '/profile' });
    // };
  }

  componentWillUnmount() {
    window.location.reload();
  }

  validationSchema() {
    return Yup.object().shape({
      email: Yup.string().required('Email is required!'),
    });
  }

  routeToSignin() {
    this.setState({
      redirect: '/signin'
    });
  }

  onSubmit(values: { email: string; }) {
    const { email } = values;

    this.setState({
      loading: true,
      success: false,
      message: ''
    });

    UserService.inquireUsername(email).then(
      async (res) => {
        console.log(`res: ${JSON.stringify(res, null, 2)}`);
        if (res.status === HttpStatusCode.Created) {
          this.setState({
            loading: false,
            success: true,
            message: res.data,
          });

          await setTimeout(()=>{}, 3000);

          this.setState({
            redirect: '/account/forgot-username-success'
          });
        } else {
          let message = res.data;

          if (res.status === HttpStatusCode.BadRequest) {
            message = 'No account found with that email';
          }

          this.setState({
            loading: false,
            success: false,
            message: message,
          });
        }
      },
      (err) => {
        console.log(`err: ${JSON.stringify(err, null, 2)}`);

        let message =
          (err.response &&
            err.response.data &&
            err.response.data.message) ||
          err.message ||
          err.toString();

        if (err.status === HttpStatusCode.BadRequest) {
          message = 'No account found with that email';
        }

        this.setState({
          loading: false,
          success: false,
          message: message
        });
      }
    );
  }

  render() {
    if (this.state.redirect) {
      return <Navigate to={this.state.redirect} />
    }

    const { loading, success, message } = this.state;

    return (
      <Layout>
        <div className='container col-md-12'>
          <Box sx={{ height: 10 }} />
          <div className='container-fluid'>
            <Typography variant='h5'><b>Forgot username</b></Typography>
          </div>
          <Box sx={{ height: 10 }} />
          <div className='container-fluid'>
            <p className='fs-3 text-description'>
              {/* { i18n.t('signin:description') } */}
              <b>Enter your email to receive your ID</b>
            </p>
          </div>
          <div className='container card card-container' style={{background: 'transparent'}}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
              <div>
                <Typography variant='caption'>* indicates required field</Typography>
              </div>
            </Box>
            <div className='container m-2' />
            <ThemeProvider theme={theme}>
              <Formik initialValues={{
                        email: '',
                      }}
                      validationSchema={this.validationSchema} 
                      onSubmit={this.onSubmit}>
                <Form>
                  <FormControl fullWidth>
                    <Typography variant='subtitle1'>
                      Email <sup style={{ color: 'rgb(224, 0, 0, 1)' }}>*</sup>
                    </Typography>
                    <Field name='email'
                           type='text'
                           as={TextField}
                           id='email'
                           variant='standard'
                           placeholder='Email Address' />
                    <ErrorMessage component='div' 
                                  name='email' 
                                  className='alert alert-danger' />
                  </FormControl>
                  <Box sx={{ height: 20 }} />
                  <Box>
                  <Button className='btn btn-success btn-block w-50' 
                          onClick={ this.routeToSignin }
                          color='success'>
                    <span>Sign In</span>
                  </Button>
                  <Button type='submit' 
                          className='btn btn-primary btn-block w-50' 
                          disabled={loading}>
                    {loading && (<span className='spinner-border spinner-border-sm mr=3'></span> )}
                    <span>Send ID</span>
                  </Button>
                  </Box>
                  <Box sx={{ height: 20 }} />
                  {message && (success?(
                    <div className='form-group'>
                      <Alert severity='success'>
                        { message }
                      </Alert>
                    </div>
                  ):(
                    <div className='form-group'>
                      <Alert severity='error'>
                        { message }
                      </Alert>
                    </div>
                  ))}
                </Form>
              </Formik>
            </ThemeProvider>
          </div>
          {/* <div className='container-fluid mt-3'>
            <p className='text-center'>
              Forgot your <a href='/pwInquiry'>Password</a> or <a href='/idInquiry'>ID</a>?
              &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;<a href='/signup'>Sign up</a>
            </p>
          </div> */}
        </div>
      </Layout>
    );
  }
}

export default withTranslation()(ForgotUsername)
